module.exports = __webpack_public_path__ + "static/media/chris.1e336b17.jpg";